import {observer_mgl} from "mobx-graphlink";
import {MapState} from "../../../../Store/main/maps/@MapState.js";
import React, {useMemo, useRef} from "react";
import * as THREE from "three";
import {useFrame, useThree} from "@react-three/fiber";
import {TransformZoomLevel} from "./MapControls.js";
import {observer_mgl_r3} from "../../../../Utils/ThreeJS/General.js";
import {mapZIndexes} from "./MapZIndexes.js";

export const CursorMarker = observer_mgl_r3((props: {mapState: MapState})=>{
	const {mapState} = props;
	const cursorPos = mapState.cursorPos;

	// show a little crosshair at the cursor position
	const size = 5;
	const color = "red";
	const crosshair_points_xAndYs = useMemo(()=>{
		const points = [
			{x: -size, y: 0, z: 0},
			{x: size, y: 0, z: 0},
			{x: 0, y: 0, z: 0},
			{x: 0, y: -size, z: 0},
			{x: 0, y: size, z: 0},
		];
		return new Float32Array(points.flatMap(a=>[a.x, a.y, a.z]));
	}, [size]);

	// update the scale each frame, so that it stays the same pixel-size regardless of zoom
	const meshRef = useRef<THREE.Mesh|null>(null);
	/*useFrame(() => {
		const zoomLevel = TransformZoomLevel(mapState.camZoom, 1.5);
		if (meshRef.current) {
			meshRef.current.scale.set(1 / zoomLevel, 1 / zoomLevel, 1);
		}
	});*/

	if (mapState.settings.general.screenshotMode) return null; // don't show cursor marker in screenshot mode
	return (
		<>
			<mesh ref={meshRef} position={cursorPos.NewZ(mapZIndexes.cursor).To3JPos()} scale={[1 / TransformZoomLevel(mapState.camZoom_0ms, 1.5), 1 / TransformZoomLevel(mapState.camZoom_0ms, 1.5), 1]}>
				{/*<planeGeometry args={[size, size]} />
				<meshBasicMaterial color={color} side={THREE.DoubleSide} />*/}

				<line>
					<bufferGeometry>
						<bufferAttribute attach="attributes-position" args={[crosshair_points_xAndYs, 3]} />
					</bufferGeometry>
					<lineBasicMaterial color={color} />
				</line>
			</mesh>
		</>
	);
});